export default {
    transform(practice) {
        if (practice === null) {
            return {}
        }

        return {
            id: practice.id,
            practiceType: practice.practiceType,
            name: practice.name,
            email: practice.email,
            insurancePlanIds: (practice.insurancePlans || []).map(({ id }) => id),
            locations: [
                {
                    name: 'Main',
                    address: practice.address,
                    city: practice.city,
                    state: practice.state,
                    zip: practice.zip,
                },
                ...(practice.locations || []).slice(1),
            ],
        }
    },
}
